var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", { staticClass: "subtitle is-4" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("component.settings.about.release_notes")) + " "
        ),
      ]),
      _vm.isLoadingReleaseNotes
        ? _c(
            "div",
            [
              _c("b-skeleton", { attrs: { width: "20%", animated: true } }),
              _c("b-skeleton", { attrs: { width: "40%", animated: true } }),
              _c("b-skeleton", { attrs: { width: "80%", animated: true } }),
              _c("b-skeleton", { attrs: { animated: true } }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "box" }, [
        _c("h2", { staticClass: "title mb-1 mt-4" }, [
          _c("i", { staticClass: "fas fa-check pr-2" }),
          _vm._v(
            _vm._s(_vm.$t("component.settings.about.validation_title")) + " "
          ),
        ]),
        _c("p", { staticClass: "has-text-weight-semibold" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("component.settings.about.validation_note")) +
              " "
          ),
        ]),
      ]),
      _vm._l(_vm.posts, function (post, index) {
        return _c("WPReleaseNote", {
          key: post.id,
          staticClass: "release-notes box",
          attrs: { postPreview: post, showInline: index == 0 },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }